export const TOUR_WEEKDAYS = [
    { value: 1, short: "Mo", label: "Montag" },
    { value: 2, short: "Di", label: "Dienstag" },
    { value: 3, short: "Mi", label: "Mittwoch" },
    { value: 4, short: "Do", label: "Donnerstag" },
    { value: 5, short: "Fr", label: "Freitag" },
] as const

export type TourWeekday = (typeof TOUR_WEEKDAYS)[number]["value"]

/** Platzhalter-Status für die Dispo-Vorschau, bis Einsätze vom Backend kommen. */
export type TourStopPreviewStatus = "open" | "done" | "problem" | "notVisited"

/** Platzhalter Typen, bis Einsätze vom Backend kommen. */

export type TourObjectRef = {
    _id: string
    objectIndication: string
    name?: string
    adress: {
        street: string
        nr: string
        plz: string
        city: string
    }
}

export type TourEmployeeRef = {
    _id: string
    first_name: string
    last_name: string
}

export type TourAdHocTask = {
    _id: string
    activity: string
    kind: "openTask" | "newTask"
    taskId?: string
}

export type TourStop = {
    _id: string
    object: TourObjectRef
    weekday: TourWeekday
    sortOrder: number
    isAdHoc?: boolean
    adHocTask?: TourAdHocTask
    previewStatus: TourStopPreviewStatus
}

export type Tour = {
    _id: string
    name: string
    active: boolean
    employee?: TourEmployeeRef
    stops: TourStop[]
}

export type TourObjectTaskStatus = "open" | "done" | "rejected" | "dismissed"
export type TourObjectTaskKind = "generated" | "adhoc" | "openTask"

/** Am Objekt hinterlegte Aufgabe, generiert aus dem Leistungsverzeichnis. */
export type TourObjectTask = {
    _id: string
    object: TourObjectRef
    catalogItem?: string
    einsatz?: string
    activity: string
    description?: string
    kind: TourObjectTaskKind
    dueWeekStart: string
    dueWeekNumber: number
    dueYear: number
    status: TourObjectTaskStatus
    rejectionComment?: string
}

export const TASK_STATUS_LABEL: Record<TourObjectTaskStatus, string> = {
    open: "Offen",
    done: "Erledigt",
    rejected: "Abgelehnt",
    dismissed: "Ausgetragen",
}

export const TASK_STATUS_COLOR: Record<TourObjectTaskStatus, string> = {
    open: "gold",
    done: "green",
    rejected: "red",
    dismissed: "default",
}

/** Operative Leistungsverzeichnis-Position je Objekt (Konzept 4.1). */
export type ServiceCatalogItem = {
    _id: string
    object?: TourObjectRef
    activity: string
    description?: string
    intervalDays: number
    intervalWeeks: number
    delayWeeks: number
    active: boolean
}

export const PREVIEW_STATUS_LABEL: Record<TourStopPreviewStatus, string> = {
    open: "Offen",
    done: "Erledigt",
    problem: "Problem",
    notVisited: "Nicht angefahren",
}

export const PREVIEW_STATUS_COLOR: Record<TourStopPreviewStatus, string> = {
    open: "gold",
    done: "green",
    problem: "red-inverse",
    notVisited: "default",
}
